/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import type { EmailLinkMethodOptions } from './EmailLinkMethodOptions';
import {
    instanceOfEmailLinkMethodOptions,
    EmailLinkMethodOptionsFromJSON,
    EmailLinkMethodOptionsFromJSONTyped,
    EmailLinkMethodOptionsToJSON,
} from './EmailLinkMethodOptions';
import type { HookMethodOptions } from './HookMethodOptions';
import {
    instanceOfHookMethodOptions,
    HookMethodOptionsFromJSON,
    HookMethodOptionsFromJSONTyped,
    HookMethodOptionsToJSON,
} from './HookMethodOptions';
import type { OIDCMethodOptions } from './OIDCMethodOptions';
import {
    instanceOfOIDCMethodOptions,
    OIDCMethodOptionsFromJSON,
    OIDCMethodOptionsFromJSONTyped,
    OIDCMethodOptionsToJSON,
} from './OIDCMethodOptions';
import type { OTPViaEmailMethodOptions } from './OTPViaEmailMethodOptions';
import {
    instanceOfOTPViaEmailMethodOptions,
    OTPViaEmailMethodOptionsFromJSON,
    OTPViaEmailMethodOptionsFromJSONTyped,
    OTPViaEmailMethodOptionsToJSON,
} from './OTPViaEmailMethodOptions';
import type { OTPViaSMSMethodOptions } from './OTPViaSMSMethodOptions';
import {
    instanceOfOTPViaSMSMethodOptions,
    OTPViaSMSMethodOptionsFromJSON,
    OTPViaSMSMethodOptionsFromJSONTyped,
    OTPViaSMSMethodOptionsToJSON,
} from './OTPViaSMSMethodOptions';
import type { PasswordMethodOptions } from './PasswordMethodOptions';
import {
    instanceOfPasswordMethodOptions,
    PasswordMethodOptionsFromJSON,
    PasswordMethodOptionsFromJSONTyped,
    PasswordMethodOptionsToJSON,
} from './PasswordMethodOptions';
import type { SAMLMethodOptions } from './SAMLMethodOptions';
import {
    instanceOfSAMLMethodOptions,
    SAMLMethodOptionsFromJSON,
    SAMLMethodOptionsFromJSONTyped,
    SAMLMethodOptionsToJSON,
} from './SAMLMethodOptions';
import type { SMSLinkMethodOptions } from './SMSLinkMethodOptions';
import {
    instanceOfSMSLinkMethodOptions,
    SMSLinkMethodOptionsFromJSON,
    SMSLinkMethodOptionsFromJSONTyped,
    SMSLinkMethodOptionsToJSON,
} from './SMSLinkMethodOptions';
import type { TOTPMethodOptions } from './TOTPMethodOptions';
import {
    instanceOfTOTPMethodOptions,
    TOTPMethodOptionsFromJSON,
    TOTPMethodOptionsFromJSONTyped,
    TOTPMethodOptionsToJSON,
} from './TOTPMethodOptions';
import type { WebAuthnMethodOptions } from './WebAuthnMethodOptions';
import {
    instanceOfWebAuthnMethodOptions,
    WebAuthnMethodOptionsFromJSON,
    WebAuthnMethodOptionsFromJSONTyped,
    WebAuthnMethodOptionsToJSON,
} from './WebAuthnMethodOptions';

/**
 * @type FactorOptions
 * 
 * @export
 */
export type FactorOptions = { method: 'email_link' } & EmailLinkMethodOptions | { method: 'hook' } & HookMethodOptions | { method: 'oidc' } & OIDCMethodOptions | { method: 'otp_via_email' } & OTPViaEmailMethodOptions | { method: 'otp_via_sms' } & OTPViaSMSMethodOptions | { method: 'password' } & PasswordMethodOptions | { method: 'saml' } & SAMLMethodOptions | { method: 'sms_link' } & SMSLinkMethodOptions | { method: 'totp' } & TOTPMethodOptions | { method: 'webauthn' } & WebAuthnMethodOptions;

export function FactorOptionsFromJSON(json: any): FactorOptions {
    return FactorOptionsFromJSONTyped(json, false);
}

export function FactorOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FactorOptions {
    if (json == null) {
        return json;
    }
    switch (json['method']) {
        case 'email_link':
            return Object.assign({}, EmailLinkMethodOptionsFromJSONTyped(json, true), { method: 'email_link' } as const);
        case 'hook':
            return Object.assign({}, HookMethodOptionsFromJSONTyped(json, true), { method: 'hook' } as const);
        case 'oidc':
            return Object.assign({}, OIDCMethodOptionsFromJSONTyped(json, true), { method: 'oidc' } as const);
        case 'otp_via_email':
            return Object.assign({}, OTPViaEmailMethodOptionsFromJSONTyped(json, true), { method: 'otp_via_email' } as const);
        case 'otp_via_sms':
            return Object.assign({}, OTPViaSMSMethodOptionsFromJSONTyped(json, true), { method: 'otp_via_sms' } as const);
        case 'password':
            return Object.assign({}, PasswordMethodOptionsFromJSONTyped(json, true), { method: 'password' } as const);
        case 'saml':
            return Object.assign({}, SAMLMethodOptionsFromJSONTyped(json, true), { method: 'saml' } as const);
        case 'sms_link':
            return Object.assign({}, SMSLinkMethodOptionsFromJSONTyped(json, true), { method: 'sms_link' } as const);
        case 'totp':
            return Object.assign({}, TOTPMethodOptionsFromJSONTyped(json, true), { method: 'totp' } as const);
        case 'webauthn':
            return Object.assign({}, WebAuthnMethodOptionsFromJSONTyped(json, true), { method: 'webauthn' } as const);
        default:
            return json;
    }
}

export function FactorOptionsToJSON(json: any): any {
    return FactorOptionsToJSONTyped(json, false);
}

export function FactorOptionsToJSONTyped(value?: FactorOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['method']) {
        case 'email_link':
            return Object.assign({}, EmailLinkMethodOptionsToJSON(value), { method: 'email_link' } as const);
        case 'hook':
            return Object.assign({}, HookMethodOptionsToJSON(value), { method: 'hook' } as const);
        case 'oidc':
            return Object.assign({}, OIDCMethodOptionsToJSON(value), { method: 'oidc' } as const);
        case 'otp_via_email':
            return Object.assign({}, OTPViaEmailMethodOptionsToJSON(value), { method: 'otp_via_email' } as const);
        case 'otp_via_sms':
            return Object.assign({}, OTPViaSMSMethodOptionsToJSON(value), { method: 'otp_via_sms' } as const);
        case 'password':
            return Object.assign({}, PasswordMethodOptionsToJSON(value), { method: 'password' } as const);
        case 'saml':
            return Object.assign({}, SAMLMethodOptionsToJSON(value), { method: 'saml' } as const);
        case 'sms_link':
            return Object.assign({}, SMSLinkMethodOptionsToJSON(value), { method: 'sms_link' } as const);
        case 'totp':
            return Object.assign({}, TOTPMethodOptionsToJSON(value), { method: 'totp' } as const);
        case 'webauthn':
            return Object.assign({}, WebAuthnMethodOptionsToJSON(value), { method: 'webauthn' } as const);
        default:
            return value;
    }
}

